import { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Card,
  Col,
  Form,
  Row,
  InputGroup,
} from "react-bootstrap";
import DataTable from "react-data-table-component";
import DatePicker from "react-datepicker";
import { CiEdit, CiFilter, CiTrash } from "react-icons/ci";
import { FaCheckCircle, FaRegEdit, FaTimesCircle } from "react-icons/fa";
import { IoAddCircleOutline, IoReloadCircle } from "react-icons/io5";
import { TbListDetails } from "react-icons/tb";
import "react-datepicker/dist/react-datepicker.css";
import { BiSearch } from "react-icons/bi";
import { RiResetLeftFill } from "react-icons/ri";
import Swal from "sweetalert2";
import { useProductDetails } from "../hooks/useProductDetails";
import ProductDetailCategoriesTableExpand from "./ProductDetailCategoriesTableExpand";
import { useNavigate } from "react-router-dom";

const ProductDetailTable = ({
  productDetailSingle,
  onEdit,
  onDelete,
  onAddDetailCategories,
  handleCategoryProductEdit,
  handleReload,
  handleClose,
}) => {
  const navigate = useNavigate();

  const [selectedRows, setSelectedRows] = useState(false);
  const [toggledClearRows, setToggleClearRows] = useState(false);

  const [filteredProducts, setFilteredProducts] = useState(
    productDetailSingle?.categoriesProduct,
  );

  const [name, setName] = useState("");

  const handleFiltersChange = () => {
    const filtered = productDetailSingle?.categoriesProduct.filter(
      (productDetail) => {
        const nameMatch = productDetail?.name
          .toLowerCase()
          .includes(name.toLowerCase());

        return nameMatch;
      },
    );

    setFilteredProducts(filtered);
  };

  const resetFilters = () => {
    setName("");
    setFilteredProducts(productDetailSingle?.categoriesProduct);
  };

  const handleAddCategoriesProductDetail = (row) => {
    // handleCategoryProductEdit(row)
    navigate("/list-product-category", { state: { row } });
  };

  const handleReloadData = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to reload the page?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, reload!",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Reloading...",
          text: "Please wait",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
            setTimeout(() => {
              Swal.close(); // Close the alert
              handleReload(); // Reload the page
              handleClose();
              window.location.reload();
            }, 2000); // Small delay to show loading briefly before reload
          },
        });
      }
    });
  };

  const columns = [
    {
      name: "No.", // Serial Number Column
      selector: (row, index) => index + 1,
      sortable: true,
      width: "60px", // Optional: Adjusts the width
    },
    {
      name: "Deskripsi",
      sortable: true,
      cell: (row) => (
        // <div style={{ display: 'flex', flexDirection: 'column' }}>
        //   <span style={{ fontWeight: 600 }}>
        //     {row?.name ? row.name : row?.Pemeriksaan}
        //   </span>
        //   <span style={{ fontSize: '12px', color: '#6c757d' }}>
        //     {row?.name ? row?.username : row?.kategori}
        //   </span>
        // </div>
        <>
          {row?.name ? (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span style={{ fontWeight: 600 }}>{row?.name}</span>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span style={{ fontWeight: 600 }}>{row?.Pemeriksaan}</span>
              <span style={{ fontSize: "12px", color: "#6c757d" }}>
                {row?.Keterangan}  ({row?.LokasiPemeriksaan})
              </span>
            </div>
          )}
        </>
      ),
    },
    { name: "Harga", selector: (row) => row?.nilai_item_detil, sortable: true },
    { name: "Qty", selector: (row) => row?.qty, sortable: true },
    // {
    //     name: 'Active', selector: row =>
    //         row?.active === 1 ? (
    //             <span style={{ color: 'green' }}>
    //                 <FaCheckCircle /> Active
    //             </span>
    //         ) : (
    //             <span style={{ color: 'red' }}>
    //                 <FaTimesCircle /> Inactive
    //             </span>
    //         )
    //     , sortable: true
    // },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <div
            style={{ display: "flex", justifyContent: "center", gap: "5px" }}
          >
            <Button
              Tooltip={"Detail"}
              variant="outline-info"
              className="m-1"
              onClick={() => handleAddCategoriesProductDetail(row)}
            >
              <TbListDetails size={16} />
            </Button>
          </div>
        </>
      ),
      center: true, // Ensures alignment within DataTable
      width: "150px", // Adjust width if needed
      omit: true,
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        fontSize: "14px", // Adjust header font size
        fontWeight: "bold",
      },
    },
    cells: {
      style: {
        fontSize: "12px", // Adjust cell font size
        padding: "0px",
        margin: "0px",
      },
    },
    rows: {
      style: {
        minHeight: "35px", // Minimum row height
        maxHeight: "35px", // Maximum row height (optional)
      },
    },
  };

  return (
    <>
      {selectedRows?.length > 0 && (
        <Button Tooltip={"test"} variant="outline-danger" className="me-1 mb-2">
          <CiTrash size={32} />
        </Button>
      )}

      <Card className="mb-2">
        <Card.Body>
          <Form>
            <Row className="align-items-center">
              {/* Name Filter */}
              <Col xs={12} sm={6}>
                <InputGroup>
                  <Form.Control
                    type="text"
                    placeholder="Search name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                  <Button
                    variant="outline-secondary"
                    onClick={handleFiltersChange}
                  >
                    <CiFilter /> Filters
                  </Button>
                  <Button variant="outline-info" onClick={resetFilters}>
                    <RiResetLeftFill /> Refresh
                  </Button>
                  {/* handleReload */}
                  <Button variant="outline-info" onClick={handleReloadData}>
                    <IoReloadCircle /> handleReload
                  </Button>
                </InputGroup>
              </Col>
            </Row>
          </Form>
          <DataTable
            title="Categories Product"
            columns={columns}
            data={
              filteredProducts?.length > 0
                ? filteredProducts
                : productDetailSingle?.categoriesProduct
            }
            pagination
            responsive
            highlightOnHover
            customStyles={customStyles}
            defaultSortFieldId={1}
            // expandableRows
            // expandableRowsComponent={ProductDetailCategoriesTableExpand}
          />
        </Card.Body>
      </Card>
    </>
  );
};

export default ProductDetailTable;
